<div class="menu-acess">
    <div class="section-toolbar">
        <span class="section-hint">Ative os menus que o usuário pode visualizar</span>
        <nz-input-group class="filter-field" [nzPrefix]="searchIcon" [nzSuffix]="clearIcon">
            <input nz-input placeholder="Buscar menu" [(ngModel)]="searchValue" />
        </nz-input-group>
        <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
        <ng-template #clearIcon>
            <nz-icon *ngIf="searchValue" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="searchValue=''"></nz-icon>
        </ng-template>
    </div>
    <nz-spin [nzSpinning]="loading">
        <nz-tree #menuTree
            [nzData]="nodes"
            [nzTreeTemplate]="nodeTpl"
            [nzSearchValue]="searchValue"
            nzBlockNode>
        </nz-tree>
        <ng-template #nodeTpl let-node let-origin="origin">
            <div class="tree-node-row">
                <nz-icon class="node-icon" [nzType]="origin.navItem.svgIconName != null ? ('custom:' + origin.navItem.svgIconName) : origin.navItem.iconName" />
                <span class="node-label">{{node.title|translateTA}}</span>
                <span class="node-toggle" (click)="$event.stopPropagation()">
                    <nz-switch nzSize="small"
                        [ngModel]="menuAllowed[origin.navItem.nuMenu] === true"
                        (ngModelChange)="toggleMenu(origin.navItem.nuMenu, $event)"
                        [nzDisabled]="!canGrant(origin.navItem.nuMenu)"></nz-switch>
                </span>
            </div>
        </ng-template>
    </nz-spin>
</div>
